module.exports = __webpack_public_path__ + "8d0499fdb1e70a62e3746b023f7399c9.png";